import axios from 'axios';

// API base URL - fallback to production URL if env var is not set
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://attendance-system-way0.onrender.com';

export const studentService = {
  // Get all students with pagination and search
  getAllStudents: async (params = {}) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/students`, { 
      params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get student by ID
  getStudentById: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/students/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Create new student
  createStudent: async (studentData) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/api/students`, studentData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Update student
  updateStudent: async (id, studentData) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_BASE_URL}/api/students/${id}`, studentData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Delete student
  deleteStudent: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_BASE_URL}/api/students/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get students by class
  getStudentsByClass: async (className) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/students/class/${className}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get all classes
  getClasses: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_BASE_URL}/api/students/classes`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }
};
